export const fr = {
  noticeBanner: {
    days_until: 'Plus que {{days}} jours avant <bold>{{eventName}}</bold> !',
    submit_request: "Soumettre une demande de bénévolat",
    black_history_month: 'Célébrons le <bold>Mois de l\'histoire des Noirs</bold> ! Demandez un événement dès aujourd\'hui.'
  }
}